import * as types from "../../mutation-types";

export default {
    [types.FETCH_SHOP_PRODUCTS_SUCCESS](state, data) {
        state.shop = data
    },

    [types.FETCH_SHOP_PRODUCTS_FAILURE](state) {
        state.shop = null
    },

    [types.FETCH_BLOG_SUCCESS](state, data) {
        state.blog = data
    },

    [types.FETCH_BLOG_FAILURE](state) {
        state.blog = null
    },

    [types.FETCH_PRODUCTS_LOG_SUCCESS](state, data) {
        state.productsLog = data
    },

    [types.FETCH_PRODUCTS_LOG_FAILURE](state) {
        state.productsLog = null
    },

    [types.CART_UPDATE](state, data) {
        state.cart = data
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/squarespace/mutations.js